import React from 'react'
import BookNow from './BookNow'

const BookService = () => (<BookNow title='Book Service' />)

export default BookService